import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Editorial } from "@/ui";
import { useMe } from "@/auth/oidc";
import { AuthLayout } from "./AuthLayout";
import { Field, OrDivider, SocialButtons } from "./fields";

export function Register() {
  const me = useMe();
  const nav = useNavigate();
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (me.isAuthenticated) nav("/today", { replace: true });
  }, [me.isAuthenticated, nav]);

  return (
    <AuthLayout
      eyebrow="get started"
      title="Start your studio"
      subtitle="A warm, honest home for your analytics. No setup ceremony — just sign up and see."
      momentLine={
        <>
          Bring your work to life, and{" "}
          <Editorial>watch it find its people.</Editorial>
        </>
      }
      footer={
        <>
          Already have an account?{" "}
          <Link to="/login" className="font-medium text-accent hover:text-accent-hover">
            Sign in
          </Link>
        </>
      }
    >
      <SocialButtons onSelect={() => me.signIn()} />
      <OrDivider />

      <form
        className="space-y-4"
        onSubmit={(e) => {
          e.preventDefault();
          me.signIn(email.trim() || undefined);
        }}
      >
        <Field
          label="Email"
          type="email"
          name="email"
          autoComplete="email"
          placeholder="you@company.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <Button variant="coral" size="lg" className="w-full" type="submit">
          Continue
        </Button>

        <p className="text-[12px] leading-relaxed text-subtle">
          You&rsquo;ll create your account securely with aigen SSO. By continuing you
          agree to the terms and privacy notice. We keep your data yours.
        </p>
      </form>
    </AuthLayout>
  );
}
